import React from 'react';
import { Dropdown, Avatar, Button, Divider } from 'antd';
import {
  MenuOutlined,
  HomeOutlined,
  MobileOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  BookOutlined,
  SecurityScanOutlined,
  ProfileOutlined,
  ControlOutlined,
  ContactsOutlined, AppstoreOutlined, BgColorsOutlined
} from '@ant-design/icons';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from '../../styles/AppHeader.module.css';

const AppHeader = () => {
  const { user, logout, hasFeature } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle logout
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Define user menu items
  const userMenuItems = [
    {
      key: 'profile',
      label: 'Profile',
      icon: <UserOutlined />,
      onClick: () => navigate('/profile'),
    },
    {
      key: 'logout',
      label: (
        <span style={{ color: 'red' }}>
          Logout
        </span>
      ), 
      icon: <LogoutOutlined style={{ color: 'red' }} />,
      onClick: handleLogout,
    },
  ];

  // User menu
  const userMenu = {
    items: userMenuItems,
  };

  // Define the main menu items
  const menuItems = [
    {
      key: '/home',
      icon: <HomeOutlined style={{ fontSize: '20px', color:'dodgerblue' }} />,
      label: <Link to="/home" style={{ fontSize: '16px' }}>Home</Link>,
    },
    {
      key: '/devices',
      icon: <MobileOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/devices" style={{ fontSize: '16px' }}>Devices</Link>,
    },
    {
      key: '/deviceconfigs',
      icon: <ControlOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/deviceconfigs" style={{ fontSize: '16px' }}>Device Config</Link>,
    },
    {
      key: '/events',
      icon: <BookOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/events" style={{ fontSize: '16px' }}>Events</Link>,
    },
    {
      key: '/participants',
      icon: <ContactsOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/participants" style={{ fontSize: '16px' }}>Participants</Link>,
      feature: 'participants.view',
    },
    {
      key: '/lead-policy',
      icon: <SecurityScanOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/lead-policy" style={{ fontSize: '16px' }}>Lead Policy Editor</Link>,
      feature: 'leadpolicy.view',
    },
    {
      key: '/lead-control',
      icon: <ProfileOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/lead-control" style={{ fontSize: '16px' }}>Lead Control</Link>,
      feature: 'lead-control.view',
    },
    {
      key: '/apps',
      icon: <AppstoreOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/apps" style={{ fontSize: '16px' }}>Apps</Link>,
    },
    {
      key: '/design',
      icon: <BgColorsOutlined style={{ fontSize: '18px', color:'dodgerblue' }} />,
      label: <Link to="/design" style={{ fontSize: '16px' }}>Design</Link>,
      feature: 'deviceConfig.design',
    },
  ];

  // Group = "admin"
  if (user?.groupID?.name === 'admin') {
    menuItems.push(
      {
        key: '',
        label: <Divider />,
      },
      {
        key: '/admin-panel',
        icon: <SettingOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
        label: <Link to="/admin-panel" style={{ fontSize: '16px' }}>Admin Panel</Link>,
      },
      {
        key: '/admin-events',
        icon: <BookOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
        label: <Link to="/admin-events" style={{ fontSize: '16px' }}>Events</Link>,
      },
      {
        key: '/admin-devices',
        icon: <MobileOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
        label: <Link to="/admin-devices" style={{ fontSize: '16px' }}>Devices</Link>,
      },
      {
        key: '/admin-deviceconfigs',
        icon: <ControlOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
        label: <Link to="/admin-deviceconfigs" style={{ fontSize: '16px' }}>Device Config</Link>,
      },
      {
        key: '/admin-entrance-control',
        icon: <SecurityScanOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
        label: <Link to="/admin-entrance-control" style={{ fontSize: '16px' }}>Entrance Control</Link>,
      },
    );
  }

  const mainMenu = {
    items: menuItems.filter(item => !item.feature || hasFeature(item.feature)),
    selectedKeys: [location.pathname],
  };

  return (
    <div className={styles.headerContainer}>
      {/* Menu button for mobile devices, left aligned */}
      <Dropdown
        menu={mainMenu}
        trigger={['click']}
        placement="bottomLeft"
      >
        <Button
          className={styles.mobileMenuButton}
          icon={<MenuOutlined />}
        />
      </Dropdown>

      {/* User menu, right-aligned */}
      <Dropdown
        menu={userMenu}
        trigger={['click']}
        placement="bottomRight"
      >
        <div className={styles.userMenuContainer}>
          <Avatar style={{ backgroundColor: '#1890ff', marginRight: '10px' }}>
            {user?.firstname.charAt(0).toUpperCase()}
            {user?.lastname.charAt(0).toUpperCase()}
          </Avatar>
          <span>
            {user?.firstname} {user?.lastname}
          </span>
        </div>
      </Dropdown>
    </div>
  );
};

export default AppHeader;